module.exports = {
  'get-callback': {
    'url': `${process.env.REACT_APP_API_PREFIX}/get-callback`,
    'callback': 'get-callback',
  },
};
